export default "__VITE_ASSET__B24A86oe__"